import * as InvoiceActionCreator from "./InvoiceActionCreator";
export function defaultInvoiceState() {
  return {
    loading: false,
    response: null,
    error: null,
    userId: "",
    projectName: "",
    fromDate: "",
    page: 0,
    size: 10,
    sortby: null,
  };
}
export const InvoiceListReducer = (state, action) => {
  if (
    !state ||
    action.type === InvoiceActionCreator.INVOICE_ACTION.RESET_INVOICE_LIST_STATE
  ) {
    return { ...state, ...defaultInvoiceState() };
  }

  if (
    action.type === InvoiceActionCreator.INVOICE_ACTION.REQUEST_INVOICE_LIST
  ) {
    return {
      ...state,
      loading: true,
      page: action.data.page,
      size: action.data.size,
      userId: action.data.userId,
      projectName: action.data.projectName,
      fromDate: action.data.fromDate,
      sortby: action.data.sortby,
    };
  }

  if (
    action.type === InvoiceActionCreator.INVOICE_ACTION.RESPONSE_INVOICE_LIST
  ) {
    return { ...state, response: action.data, loading: false };
  } 

  if (action.type === InvoiceActionCreator.INVOICE_ACTION.ERROR_INVOICE_LIST) {
    return {
      ...state,
      error: action.data,
      loading: false,
      response: null,
      page: 0,
      size: 10,
    };
  }
  return state;
};

export function defaultUpdateInvoiceState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}
export const UpdateInvoiceReducer = (state, action) => {
  if (
    !state ||
    action.type === InvoiceActionCreator.INVOICE_ACTION.RESET_UPDATE_INVOICE
  ) {
    return { ...state, ...defaultUpdateInvoiceState() };
  }

  if (
    action.type === InvoiceActionCreator.INVOICE_ACTION.REQUEST_UPDATE_INVOICE
  ) {
    return {
      ...state,loading: true,response: null,error: null,
    };
  }

  if (
    action.type === InvoiceActionCreator.INVOICE_ACTION.RESPONSE_UPDATE_INVOICE
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type === InvoiceActionCreator.INVOICE_ACTION.ERROR_UPDATE_INVOICE
  ) {
    return {
      ...state,error: action.data,loading: false,response: null,
    };
  }
  return state;
};


export function defaultReGenerateInvoicePDF() {
  return {
    loading: false,
    response: null,
    error: null,
    invoiceId:"",
    hourRate:"",
  };
}
export const ReGenerateInvoicePDFReducer = (state, action) => {
  if (
    !state ||
    action.type ===
      InvoiceActionCreator.INVOICE_ACTION.RESET_REGENERATE_INVOICE_STATE
  ) {
    return { ...state, ...defaultReGenerateInvoicePDF() };
  }

  if (
    action.type ===
    InvoiceActionCreator.INVOICE_ACTION.REQUEST_REGENERATE_INVOICE
    ) {
    return { ...state, 
      loading: true,
      invoiceId:action.data.invoiceId || "",
      hourRate: action.data.hourRate ? parseFloat(action.data.hourRate) : 0, 
     };
  }

  if (
    action.type ===
    InvoiceActionCreator.INVOICE_ACTION.RESPONSE_REGENERATE_INVOICE
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type ===
    InvoiceActionCreator.INVOICE_ACTION.ERROR_REGENERATE_INVOICE
  ) {
    return { ...state, error: action.data, loading: false };
  }

  return state;
};

export function defaultInvoicePaymentDate() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}
export const InvoicePaymentDateReducer = (state, action) => {
  if (
    !state ||
    action.type === InvoiceActionCreator.INVOICE_ACTION.RESET_INVOICE_PAYMENT_DATE
  ) {
    return { ...state, ...defaultInvoicePaymentDate() };
  }

  if (
    action.type === InvoiceActionCreator.INVOICE_ACTION.REQUEST_INVOICE_PAYMENT_DATE
  ) {
    return {
      ...state,loading: true,response: null,error: null,
    };
  }

  if (
    action.type === InvoiceActionCreator.INVOICE_ACTION.RESPONSE_INVOICE_PAYMENT_DATE
  ) {
    return { ...state, response: action.data, loading: false };
  }

  if (
    action.type === InvoiceActionCreator.INVOICE_ACTION.ERROR_INVOICE_PAYMENT_DATE
  ) {
    return {
      ...state,error: action.data,loading: false,response: null,
    };
  }
  return state;
};

export function defaultInvoiceHoursState() {
  return {
    hours: "",
  };
}

export const InvoiceHoursReducer = (state, action) => {
  if (!state || action.type === InvoiceActionCreator.INVOICE_ACTION.RESET_INVOICE_HOURS) {
    return { ...state, ...defaultInvoiceHoursState() };
  }

  if (action.type === InvoiceActionCreator.INVOICE_ACTION.SET_INVOICE_HOURS) {
    return { ...state, hours: action.data };
  }

  return state;
};

export function defaultInvoicesInfoById() {
  return {
    loading: false,
    response: null,
    error: null,
  };

}
export const InvoiceInfoById=(state,action)=>{
  if(!state || action.type === InvoiceActionCreator.INVOICE_ACTION.RESET_INVOICE_INFO_BY_ID){
    return {...state,...defaultInvoicesInfoById()};
  }
  if(action.type === InvoiceActionCreator.INVOICE_ACTION.REQUEST_INVOICE_INFO_BY_ID){
    return {...state,loading:true,response:null,error:null};
  }
  if(action.type === InvoiceActionCreator.INVOICE_ACTION.RESPONSE_INVOICE_INFO_BY_ID){
    return {...state,response:action.data,loading:false};
  }
  if(action.type === InvoiceActionCreator.INVOICE_ACTION.ERROR_INVOICE_INFO_BY_ID){
    return {...state,error:action.data,loading:false,response:null};
  }
  return state;
}

